import Container from '@material-ui/core/Container';
import { Styles } from 'components/Tools';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useTypedSelector } from 'hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

export const PageNotFound = () => {
  const classes = useStyles();
  const mySession = useTypedSelector((s) => s.session);

  return (
      <Container component="main" maxWidth="sm" className={classes.root}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h4" gutterBottom>
          Página no encontrada
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </Typography>
        {mySession.error?.name && (
            <Typography variant="body2" color="error">
              Error: {mySession.error.message}
            </Typography>
        )}
        <Button
            variant="contained"
            color="primary"
            className={classes.button}
            href="/"
        >
          Volver al inicio
        </Button>
      </Container>
  );
};
